<template>
  <div class="emergency-response">
    <Card :dis-hover="true" :bordered="true">
      <template #extra>
        <Icon v-if="$route" type="md-refresh" :size="22"
              @click="goRefresh"
              style="cursor: pointer;margin-right: 10px"
        />
        <Icon v-if="$route" type="md-close" :size="22"
              @click="goBack"
              style="cursor: pointer"
        />
      </template>
      <el-descriptions class="margin-top" title="事件信息" size="medium" :column="2" border
                       :labelStyle="{'text-align': 'center','width':'15%','color':'#555'}">
        <el-descriptions-item label="事件标题" :span="2">
          {{ eInfo.eventTitle }}
        </el-descriptions-item>
        <el-descriptions-item label="事发地点">
          {{ eInfo.incidentArea }}
          <Button type="primary" @click="selMonitorModalShow()">选择监控</Button>
        </el-descriptions-item>
        <el-descriptions-item label="事件类型">
          {{ eInfo.eventTypeName }}
        </el-descriptions-item>
        <el-descriptions-item label="事件描述" :span="2">
          {{ eInfo.eventDescription }}
          <!--          （原因、路产损失情况、交通状况、人员伤亡情况）-->
        </el-descriptions-item>
        <el-descriptions-item label="上报人">
          {{ eInfo.reportPerson }}
        </el-descriptions-item>
        <el-descriptions-item label="上报电话">
          {{ eInfo.reportPhone }}
        </el-descriptions-item>
        <el-descriptions-item label="事件照片">
          <div v-if="eInfo.eventImgPath && eInfo.eventImgPath.length > 0"
               style="display: flex;flex-direction: row;flex-wrap: wrap;align-content: flex-start;">
            <!--            <img v-for="(item,index) in eInfo.eventImgPath" :src="item.url" :key="index" width="200" height="200"-->
            <!--                 style="margin-right: 10px" @click="previewPic(item)"/>-->
            <el-image v-for="(item,index) in eInfo.eventImgPath" :key="index"
                      style="width: 200px; height: 200px;margin-top: 10px;margin-right: 10px;"
                      :src="item"
                      :preview-src-list="eInfo.eventImgPath">
            </el-image>
          </div>
          <div v-else>无</div>
        </el-descriptions-item>
        <!--        <el-descriptions-item label="选择监控">-->
        <!--          <Button type="primary"@click="selMonitorModalShow()">选择监控</Button>-->
        <!--        </el-descriptions-item>-->
      </el-descriptions>
    </Card>
    <!--    <div class="map" id="map"  v-loading="mapLoading"></div>-->
    <Card v-if="eInfo.isDrill!=='0'" :dis-hover="true" style="margin-top: 10px">
      <el-steps :active="curStep" align-center finish-status="success">
        <!--        <el-step title="开始" description="开始">-->
        <!--        </el-step>-->
        <el-step v-for="(item,index) in stepList" :key="index" @click.native="showModule(item, index)">
          <template #title>
            <div style="font-size: 16px">
              {{ item.disposalProcess.operate !== null ? item.disposalProcess.operate : item.disposalProcess.name }}
            </div>
          </template>
          <template #description>
            <div>{{ item.disposalProcess.name }}</div>
            <div>{{ item.jumpTime === null ? '' : $moment(item.jumpTime).format('YYYY-MM-DD HH:mm') }}</div>
          </template>
        </el-step>
      </el-steps>
      <Card v-if="curComponent !== 0&&curComponent !== 1" :bordered="false" :dis-hover="true"
            :title="compConfigList[curComponent].label" style="margin-top: 16px">
        <el-image src="https://dzgllw.com/uploadFile/quxian.png"
                  :preview-src-list="['https://dzgllw.com/uploadFile/quxian.png']"
                  style="width: 30%;height: 200px"></el-image>
        <component style="display: inline-block;vertical-align: top;width: 60%" :is="compConfigList[curComponent].cName"
                   :eventInfo="eInfo"
                   :stepInfo="curStepInfo"
                   :preStep="preStep"
                   @refreshStep="refreshStep"/>
      </Card>
    </Card>
    <Modal
      v-model="showPic"
      title="预览"
      :footer-hide="true"
    >
      <img alt="" :src="selectPic.url" width="100%" height="100%"/>
    </Modal>
    <!--    <Modal v-model="monitorModal" title="实时监控" :width="50" footer-hide @on-visible-change="visibleChange">-->
    <!--      <div class="content">-->
    <!--        <JessibucaVideo id="jessibuca" ref="jessibuca" class="video"-->
    <!--                        :video-url="`${$videoUrl}/rtp/${currentMonitor['deviceId']}_${currentMonitor['deviceId']}.live.flv`"/>-->
    <!--      </div>-->
    <!--    </Modal>-->
    <Modal title="选择监控" v-model="selMonitorModalIsShow" :width="50" @on-cancel="MonitorModalCancel">
      <Row :gutter="12">
        <Col :span="12">
          <Card dis-hover title="固定监控">
            <div style="height: 300px;overflow: auto">
              <CheckboxGroup v-model="selMonitorTwo" @on-change="monitorChange">
                <Checkbox :disabled="item.streamingstatus!=='normal'" border style="margin-top: 10px;width: 80%"
                          v-for="(item,index) in monitorListOfTwo" :key="index" :label="item">
                  {{ item.name }}
                </Checkbox>
              </CheckboxGroup>
            </div>
          </Card>
        </Col>
        <Col :span="12">
          <Card dis-hover title="移动监控">
            <div style="height: 300px;overflow: auto">
              <CheckboxGroup v-model="selMobileMonitorList" @on-change="monileMonitorChange">
                <Checkbox :disabled="item.status===0" border style="margin-top: 10px;width: 80%"
                          v-for="(item,index) in mobileList" :key="index" :label="item">
                  {{ item.deviceName }}
                </Checkbox>
              </CheckboxGroup>
            </div>
          </Card>
        </Col>
      </Row>
      <template slot="footer">
        <el-button @click="closeSelMonitor">取消</el-button>
        <el-button type="primary" @click="monitorPlayShow">确定</el-button>
      </template>
    </Modal>
    <Modal title="视频播放" v-model="monitorPlayIsShow" :width="65" footer-hide @on-cancel="cancelMonitorPlayModal">
      <div v-if="selMobileMonitorList.length>0"
           style="width: 100%;display: flex;flex-direction: row;flex-wrap: wrap;margin-top: 10px;">
        <span style="width: 100%">移动监控</span>
        <div v-for="(item,index) in selMobileMonitorList" :key="index" style="width:48%;margin-right: 10px">
          <VideoComp :v-data="item"></VideoComp>
        </div>
      </div>
      <div v-if="selMonitorTwo.length>0" id="playVideo" style="height: 600px">
        <div v-if="selMonitorTwo.length <=4" style="margin-top: 10px">
          <span style="width: 100%">固定监控</span>
          <jessibuca4 ref="jessibuca4" :videolist="videolist" :streamStatusList="streamStatusList"
                      :isFullScreen="isFullScreen" :videonamelist="videonamelist"
                      :cameraTypeList="cameraTypeList" :cameraDetailList="cameraDetailList"></jessibuca4>
        </div>
        <div v-if="selMonitorTwo.length >4" style="margin-top: 10px">
          <jessibuca9 ref="jessibuca9" :videolist="videolist" :streamStatusList="streamStatusList"
                      :isFullScreen="isFullScreen" :videonamelist="videonamelist"
                      :cameraTypeList="cameraTypeList" :cameraDetailList="cameraDetailList"></jessibuca9>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import JessibucaVideo from '@/views/Screen/components/Video/JessibucaVideo.vue'
import Jessibuca4 from '@/views/stereoscopicInspection/components/flvh265-4.vue'
import Jessibuca9 from '@/views/stereoscopicInspection/components/flvh265-9.vue'
import VideoComp from "@/views/TianyiVideo/components/VideoComp.vue";
import {defineAsyncComponent} from "vue";

export default {
  name: "emergencyResponse",
  components: {
    VideoComp,
    JessibucaVideo,
    Jessibuca4,
    Jessibuca9
  },
  props: {
    eventInfo: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      token: '',
      MobileMonitorIsShow: false,
      isFullScreen: false,
      videolist: [],
      streamStatusList: [],
      videonamelist: [],
      cameraTypeList: [],
      cameraDetailList: [],
      monitorPlayIsShow: false,
      selMonitorTwo: [],
      selMonitorModalIsShow: false,
      mapLoading: false,
      monitorModal: false,
      currentMonitor: {},
      showPic: false,
      selectPic: {},
      eInfo: {},
      stepList: [],
      curStep: 0,
      curStepInfo: '',
      closeOfflinePlay: true,
      preStep: '',
      curComponent: 0,
      map: null,
      monitorList: [],
      monitorListOfTwo: [],
      MobileList: [],
      MobileAndIsLineList: [],
      selMobileMonitorList: [],
      dataTotal: 0,
      btnLoading: false,
      regionId: '',
      regionmId: '',
      loginUrl: '',
      accessToken: '',
      byCodeResult: null,
      cbUrl: '',
      authCode: null,
      theRequest: {},
      videoList: [],
      deviceList: [],
      onDeviceList: [],
      local: '',
      deviceCount: 0,
      onlineCount: 0,
      videoHlsUrls: [],
      vData: null,
      mobileList: [],
      compConfigList: [
        {
          label: '接警核实',
          name: '值班人员',
          cName: null
        },
        {
          label: '审核',
          name: '值班领导',
          cName: null
        },
        {
          label: '判定事件等级',
          name: '中心应急领导小组',
          cName: defineAsyncComponent(() => import('@/views/emergencyResponse/components/eventLevel/eventLevel.vue'))
        },
        {
          label: '制定先期处置方案',
          name: '县区中心应急领导小组',
          cName: defineAsyncComponent(() => import('@/views/emergencyResponse/components/disposalPlan/disposalPlan.vue'))
        },
        {
          label: '专家会商',
          name: '市中心应急领导小组',
          cName: defineAsyncComponent(() => import('@/views/emergencyResponse/components/expertConsultation/expertConsultation.vue'))
        },
        {
          label: '调配资源',
          name: '县区中心应急领导小组',
          cName: defineAsyncComponent(() => import('@/views/emergencyResponse/components/matchingPlan/matchingPlan.vue'))
        },
        {
          label: '支援物资',
          name: '市中心应急领导小组',
          cName: defineAsyncComponent(() => import('@/views/emergencyResponse/components/centralScheduling/centralScheduling.vue'))
        },
        {
          label: '现场处置',
          name: '现场处置',
          cName: defineAsyncComponent(() => import('@/views/emergencyResponse/components/siteDisposal/siteDisposal.vue'))
        },
        {
          label: '评估验收',
          name: '评估验收',
          cName: defineAsyncComponent(() => import('@/views/emergencyResponse/components/eventEvaluation/eventEvaluation.vue'))
        },
        // {
        //   label: '验收',
        //   name: '验收',
        //   cName: defineAsyncComponent(() => import('@/views/emergencyResponse/components/checkAccept/checkAccept.vue'))
        // },
        {
          label: '响应终止',
          name: '响应终止',
          cName: null
        }
      ], //动态加载表单配置
    }
  },
  mounted() {
    this.getEventDetails()
    // this.getAllMonitor()
    this.getToken()
  },
  methods: {
    playMobileVideo() {
      this.$nextTick(() => {
        this.vData = {
          hlsurl: this.videoHlsUrl, //视频url地址
          cameraId: 'fid0' //id
        }
        // this.$refs.jessibuca.play()
      })
    },
    gotoDeviceList() {
      this.$router.push({
        name: 'deviceList',
        query: {
          regionId: this.regionmId
        }
      })
    },
    getToken() {
      this.$http.get(`/api/tysl/getToken`).then(res => {
        // console.log(res)
        if (res.data.status === '200') {
          this.accessToken = res.data.data.accessToken
          if (this.accessToken === null) {
            this.loginUrl = res.data.data.loginUrl
            window.open(this.loginUrl, '_self')
            // window.open(this.loginUrl)
          } else {
            localStorage.setItem('tyToken', this.accessToken)
            this.getRequestCode()
          }
        }
      })
    },
    getRequestCode() {
      // this.local = "http://219.146.4.90:8080/tianyi/TianyiVideo?authCode=aBFIll9wQoSx1hiQFB99YpGs&errorCode=0"
      // var url = this.local
      this.local = window.location
      var url = this.local.hash
      if (url.indexOf("?") != -1) {
        var str = url.split("?")[1]
        var strs = str.split("&")
        for (var i = 0; i < strs.length; i++) {
          this.theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1])
        }
      }
      if (this.theRequest.authCode) {
        this.authCode = this.theRequest.authCode
        this.getTokenByCode()
      } else {
        this.getDeviceCount()
        this.getVideoList()
      }
      // console.log(this.authCode)
    },
    ///api/tysl/getTokenByCode？code=
    getTokenByCode() {
      this.$http.get(`/api/tysl/getTokenByCode?code=${this.authCode}`).then(res => {
        // console.log(res)
        this.byCodeResult = res
        if (res.data.status === '200') {
          this.accessToken = res.data.data.accessToken
          localStorage.setItem('tyToken', this.accessToken)
          this.getDeviceCount()
          this.getVideoList()
        }
      })
    },
    getVideoList() {
      this.$http.get(`/api/tysl/getReginWithGroupList?accessToken=${this.accessToken}&regionId=${this.regionId}`).then(res => {
        console.log(res)
        if (res.data.status === '200') {
          this.videoList = res.data.data
          for (var i = 0; i < res.data.data.length; i++) {
            if (res.data.data[i].name === '移动设备') {
              this.regionmId = res.data.data[i].id
              this.getDeviceList()
            }
          }
        }
      })
    },
    getDeviceCount() {
      this.$http.get(`/api/tysl/getCusTreeDeviceCount?accessToken=${this.accessToken}&isClearCache=0`).then(res => {
        // console.log(res)
        if (res.data.status === '200') {
          this.deviceCount = res.data.data.deviceCount
          this.onlineCount = res.data.data.onlineCount
          this.btnLoading = false
        }
      })
    },
    refreshAll() {
      this.btnLoading = true
      this.getDeviceCount()
      this.getVideoList()
    },
    getDeviceList() {
      this.$http.get(`/api/tysl/getDeviceList?accessToken=${this.accessToken}&regionId=${this.regionmId}&pageNo=1&&pageSize=10`).then(res => {
        console.log(res)
        if (res.data.status === '200') {
          this.deviceList = res.data.data.list
          this.getBatchDeviceStatus()
        }
      })
    },
    //获取在线设备/api/tysl/batchDeviceStatus
    getBatchDeviceStatus() {
      let deviceCodes = this.deviceList.map(item => item.deviceCode).toString()
      this.$http.get(`/api/tysl/batchDeviceStatus?accessToken=${this.accessToken}&deviceCodes=${deviceCodes}`).then(res => {
        if (res.data.status === '200') {
          this.onDeviceList = res.data.data.filter(item => item.status == 1)
          console.log(this.onDeviceList)
          this.getVideoHls()
        }
      })
    },
    getVideoHls() {
      if (this.onDeviceList.length === 0) return
      for (var i = 0; i < this.onDeviceList.length; i++) {
        this.getHls(this.onDeviceList[i].deviceCode, i)
      }
    },
    getHls(deviceCode, index) {
      this.$http.get(`/api/tysl/getDeviceMediaUrlHls?accessToken=${this.accessToken}&deviceCode=${deviceCode}`).then(res => {
        console.log(res.data.data)
        if (res) {
          console.log(res)
          let ob = JSON.parse(res.data.data)
          console.log(ob)
          ob.url = ob.url.replace('liveplay.vaas.cn-qingdao-1.ctyunxs.cn', 'dzgllw.com')
          this.videoHlsUrls.push({
            hlsurl: ob.url, //视频url地址
            cameraId: 'fid' + index, //id
            // 截取https://liveplay.vaas.cn-qingdao-1.ctyunxs.cn/vaas/live/3702000110003_37147107021322001679_live_1/hls.m3u8?auth_key=1699603688-2044db8283a94449923729d162d7a9f5-30003中的37147107021322001679
            cameraCode: ob.url.split('/')[5].split('_')[1]
          })
          console.log(this.videoHlsUrls, this.deviceList)
          this.mobileList = this.mergeArray(this.deviceList, this.videoHlsUrls)
          console.log('resssssssssssssss', mobileList)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    //根据deviceCode合并两个数组
    mergeArray(arr1, arr2) {
      let arr3 = []
      for (let i in arr1) {
        for (let j in arr2) {
          if (arr1[i].deviceCode === arr2[j].cameraCode) {
            arr3.push(Object.assign(arr1[i], arr2[j]))
          }
        }
      }
      return arr3
    },
    MonitorModalCancel() {
      this.selMonitorModalIsShow = false
      this.selMonitorTwo = []
      this.selMobileMonitorList = []
    },
    cancelMonitorPlayModal() {
      this.monitorPlayIsShow = false
      this.selMonitorTwo = []
      this.selMobileMonitorList = []
      this.destoryVideo()
    },
    monitorPlayShow() {
      if (this.selMonitorTwo.length === 0 && this.selMobileMonitorList.length === 0) {
        this.$Message.error('请选择监控')
        return
      }
      console.log(this.selMonitorTwo)
      this.monitorPlayIsShow = true
      this.selMonitorModalIsShow = false
      // if (this.selMobileMonitorList.length > 0) {
      //   this.MobileMonitorIsShow = true
      // }
      this.$nextTick(() => {
        this.switchStart()
      })
    },
    // // 获取生产的token
    // getToken() {
    //   this.$http.get(`/api/tysl/getToken`).then(res => {
    //     if (res.status === 200) {
    //       this.token = res.data.data.accessToken
    //       this.$nextTick(() => {
    //         this.getMobileList()
    //       })
    //     }
    //   })
    // },
    // // 获取移动设备列表
    // getMobileList() {
    //   this.$http.get(`/api/tysl/getDeviceList`, {
    //     params: {
    //       accessToken: this.token,
    //       pageNo: 1,
    //       pageSize: 50,
    //       regionId: 81608221
    //     }
    //   }).then(res => {
    //     if (res.status === 200) {
    //       this.MobileList = res.data.data.list
    //       this.getIsOnline()
    //     }
    //   })
    // },
    // // 获取是否在线接口
    // getIsOnline() {
    //   let deviceCodesList = []
    //   for (let i in this.MobileList) {
    //     deviceCodesList.push(this.MobileList[i].deviceCode)
    //   }
    //   this.$http.get(`/api/tysl/batchDeviceStatus`, {
    //     params: {
    //       accessToken: this.token,
    //       deviceCodes: deviceCodesList.join(',')
    //     }
    //   }).then(res => {
    //     if (res.status === 200) {
    //       this.MobileAndIsLineList = this.mergeArray(this.MobileList, res.data.data)
    //       console.log(this.MobileAndIsLineList)
    //     }
    //   })
    // },
    // // 根据deviceCode合并两个数组
    // mergeArray(arr1, arr2) {
    //   let arr3 = []
    //   for (let i in arr1) {
    //     for (let j in arr2) {
    //       if (arr1[i].deviceCode === arr2[j].deviceCode) {
    //         arr3.push(Object.assign(arr1[i], arr2[j]))
    //       }
    //     }
    //   }
    //   return arr3
    // },
    monitorChange() {
      // console.log(item)
      console.log(this.selMonitorTwo)
      let videos = this.formatData(this.selMonitorTwo)
      this.videolist = videos[0];
      this.streamStatusList = videos[1];
      this.videonamelist = videos[2];
      this.cameraTypeList = videos[3];
      this.cameraDetailList = videos[4];
    },
    monileMonitorChange() {
      console.log(this.selMobileMonitorList)
    },
    destoryVideo() {
      if (this.selMonitorTwo.length > 4) {
        this.$refs.jessibuca9.batchDestoryVideo();
      } else if (this.selMonitorTwo.length < 4) {
        this.$refs.jessibuca4.batchDestoryVideo();
      }
    },
    destoryReverseVideo() {
      if (this.selMonitorTwo.length < 4) {
        this.$refs.jessibuca4.batchDestoryVideo();
      } else if (this.selMonitorTwo.length > 4) {
        this.$refs.jessibuca9.batchDestoryVideo();
      }
    },
    closeSelMonitor() {
      this.selMonitorModalIsShow = false
      this.monitorListOfTwo = []
      this.selMonitorTwo = []
    },
    selMonitorModalShow() {
      this.selMonitorModalIsShow = true
      this.getMonitor()
    },
    // 获取200m之内的监控
    getMonitor() {
      this.$http.get(`/api/getCameraList`, {
        params: {
          longitude: this.eInfo.longitude,
          latitude: this.eInfo.latitude,
          // distance: 200
        }
      }).then(res => {
        if (res.status === 200) {
          this.monitorListOfTwo = res.data
        }
      })
    },
    switchStart() {
      if (this.selMonitorTwo.length > 4) {
        this.$refs.jessibuca9.switchStart();
      } else if (this.selMonitorTwo.length < 4) {
        this.$refs.jessibuca4.switchStart();
      }
    },
    formatData(data) {
      let videolist = [];
      let streamStatusList = [];
      let videonamelist = [];
      let cameraTypeList = []
      let cameraDetailList = []
      let closeOfflinePlay = this.closeOfflinePlay;
      for (const item of data) {
        console.log(item)
        if (item.deviceCode) {
          item['stream_url'] = `${this.$videoUrl}/rtp/${item['deviceCode']}_${item['deviceCode']}.live.flv`
          if (item['status'] === 1) {
            streamStatusList.push('online');
            videolist.push(item['stream_url']);
            videonamelist.push(item['deviceName']);
            // cameraTypeList.push(item['deviceType'])
            cameraDetailList.push(item)
          } else {
            if (!closeOfflinePlay) {
              videolist.push(item['stream_url']);
              streamStatusList.push('offline');
              videonamelist.push(item['deviceName']);
            }
          }
        } else {
          item['stream_url'] = `${this.$videoUrl}/rtp/${item['indexcode']}_${item['indexcode']}.live.flv`
          if (item['streamingstatus'] === 'normal') {
            streamStatusList.push('online');
            videolist.push(item['stream_url']);
            videonamelist.push(item['name']);
            cameraTypeList.push(item['cameratype'])
            cameraDetailList.push(item)
          } else {
            if (!closeOfflinePlay) {
              videolist.push(item['stream_url']);
              streamStatusList.push('offline');
              videonamelist.push(item['name']);
            }
          }
        }
      }
      return [videolist, streamStatusList, videonamelist, cameraTypeList, cameraDetailList]
    },
    visibleChange(flag) {
      if (flag) {
        this.playVideo()
      } else {
        this.close()
      }
    },
    // 根据id获取事件信息
    getEventDetails() {
      let id = this.$route ? this.$route.query.id : this.eventInfo.id
      this.$http.get(`/api/messageReceptions/${id}`).then(res => {
        if (res.status === 200) {
          this.eInfo = res.data
          this.formatImgPath()
          this.getLinks()
          // this.$nextTick(() => {
          //   this.initMap()
          // })
        }
      })
    },
    initMap() {
      this.map = new BMapGL.Map("map");          // 创建地图实例
      let point = new BMapGL.Point(parseFloat(this.eInfo.longitude), parseFloat(this.eInfo.latitude));  // 创建点坐标
      this.map.centerAndZoom(point, 18);
      this.map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
      this.showPoint()
    },
    // 获取所有监控
    getAllMonitor() {
      this.mapLoading = true
      this.$http.post(`/api/point/monitorPoint?page=1&size=99999`, {}).then(res => {
        if (res.status === 200) {
          this.mapLoading = false
          this.monitorList = res.data.data.list
          // 显示点位
          this.monitorList.forEach(item => {
            let icon = new BMapGL.Icon(require('./image/jiankonglan.png'), new BMapGL.Size(20, 25));
            let huiIcon = new BMapGL.Icon(require('./image/jiankonghui.png'), new BMapGL.Size(20, 25));
            let point = new BMapGL.Point(parseFloat(item.longitude), parseFloat(item.latitude));  // 创建点坐标
            let marker = new BMapGL.Marker(point, {
              icon: item.streamingstatus === 'normal' ? icon : huiIcon,
              title: '事件所在监控'
            });        // 创建标注
            this.map.addOverlay(marker);                     // 将标注添加到地图中
            marker.addEventListener('click', () => {
              if (item.streamingstatus === 'abnormal') {
                this.$Message.error('该监控不在线')
                return
              }
              this.monitorModal = true
              this.currentMonitor = item
              // console.log(item)
            })
          })
        }
      })
    },
    // 显示点位
    showPoint() {
      let icon = new BMapGL.Icon(require('./image/jiankonglan.png'), new BMapGL.Size(20, 25));
      let point = new BMapGL.Point(parseFloat(this.eInfo.longitude), parseFloat(this.eInfo.latitude));  // 创建点坐标
      let marker = new BMapGL.Marker(point, {title: '事件所在监控'});        // 创建标注
      console.log('标注', point)
      marker.addEventListener('click', () => {
        this.monitorModal = true
        this.currentMonitor = this.eInfo
      })
      // this.map.addOverlay(marker);                     // 将标注添加到地图中
      let circle = new BMapGL.Circle(point, 100, {
        strokeColor: "red",
        strokeWeight: 2,
        strokeOpacity: 0.5,
        fillColor: "blue",
        fillOpacity: 0.2
      }); //创建圆
      this.map.addOverlay(circle); //增加圆
    },
    playVideo() {
      this.$nextTick(() => {
        // const url = `ws://144.123.135.25:8091/rtp/${this.item['deviceId']}_${this.item['deviceId']}.live.flv`
        this.$refs.jessibuca.play()
      })
    },
    close() {
      this.$refs.jessibuca.destroy()
    },
    fullScreen() {
      this.$refs.jessibuca.fullscreen()
    },
    goRefresh() {
      this.getMessgeInfo()
    },
    formatImgPath() {
      if (this.eInfo.eventImgPath !== null && this.eInfo.eventImgPath !== '') {
        // console.log(this.eInfo.eventImgPath)
        let paths = this.eInfo.eventImgPath.split(';')
        this.eInfo.eventImgPath = paths
        // this.eInfo.eventImgPath = paths.map(path => {
        //   return path
        // })
      }
    },
    previewPic(item) {
      this.showPic = true
      this.selectPic = item
    },
    goBack() {
      this.$router.go(-1)
      this.$store.commit('app/closePage', {
        vm: this,
        fromName: this.$route.name,
      })
    },
    showModule(item, index) {
      console.log(item)
      if (index === 1 && index === 0) return
      console.log(this.compConfigList)
      this.curComponent = this.compConfigList.findIndex(comp => item.disposalProcess.operate === comp.label)
      this.curStepInfo = this.stepList[index].information
      console.log(this.curStepInfo)
      if (index === 4 && this.eInfo.eventLevel === '1') {
        this.preStep = this.stepList[3].information
      }
      if (index === 3 && this.eInfo.eventLevel === '2') {
        this.preStep = this.stepList[2].information
      }
    },
    getLinks() {
      this.$Loading.start()
      let params = {
        messageId: this.eInfo.id,
        eventLevel: this.eInfo.eventLevel,
        eventSeverity: this.eInfo.eventSeverity,
        indexCode: this.eInfo.deptIndexCode
      }
      this.$http.post('/api/getLinks', params).then(res => {
        // console.log(res)
        if (res.status === 200) {
          this.$Loading.finish()
          this.stepList = res.data.data
          let slist = []
          for (var s = 0; s < this.stepList.length; s++) {
            let issupport = false
            if (this.stepList[s].disposalProcess.id === '6' && this.stepList[s - 1].information !== null) {
              let info = this.stepList[s - 1].information.split(';')
              // console.log(info)
              for (var i = 0; i < info.length; i++) {
                const obj = info[i].split('_')
                if (obj[0] === 'sendingMethod') {
                  if (obj[1] === '0') {
                    issupport = true
                  }
                }
              }
            }
            if (!issupport) {
              slist.push(this.stepList[s])
            }
          }
          this.stepList = slist
          this.curStep = this.stepList.findIndex(item => Number(item.disposalProcess.id) === this.eInfo.currentLink)
          this.curComponent = this.compConfigList.findIndex(comp => this.stepList[this.curStep].disposalProcess.operate === comp.label)
          this.curStepInfo = this.stepList[this.curStep].information
          console.log('curStep', this.curStep, this.eInfo.currentLink)
          if (this.curStep === 4 && this.eInfo.eventLevel === '1') {
            this.curStepInfo = this.stepList[3].information
          }
          if (this.curStep === 3 && this.eInfo.eventLevel === '2') {
            this.curStepInfo = this.stepList[2].information
          }
        }
      }).catch(err => {
        console.log(err)
        this.$Loading.error()
      })
    },
    getMessgeInfo() {
      this.$http.get(`/api/messageReceptions/${this.eInfo.id}`).then(res => {
        console.log(res)
        this.eInfo = res.data
        this.formatImgPath()
        this.getLinks()
      })
    },
    refreshStep() {
      this.getMessgeInfo()
      // this.getLinks()
    }
  }
}
</script>

<style scoped lang="less">
#map {
  height: 400px;
  width: 60%;
  margin: 0 auto;
}

.emergency-response {
  height: 100%;
  overflow: auto;

  .el-step {
    cursor: pointer;

    :deep(.el-step__description) {
      padding: 0;
      margin-top: 0;
    }
  }
}

.content {
  width: 100%;
  height: 400px;
  position: relative;

  .video {
    position: absolute;
    width: 100%;
    height: 100%;
    //height: 15vh;
    top: 0;
    left: 0;
  }
}

.video {
  position: absolute;
  width: 100%;
  height: 100%;
  //height: 15vh;
  top: 0;
  left: 0;
}

</style>
